export default function Nutrition() {
  const nutritionFeatures = [
    {
      icon: 'ri-restaurant-line',
      title: 'Repas équilibrés',
      description: 'Menus variés préparés avec des ingrédients frais et nutritifs'
    },
    {
      icon: 'ri-apple-line',
      title: 'Collations santé',
      description: 'Collations nutritives pour maintenir l\'énergie tout au long de la journée'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Croissance optimale',
      description: 'Alimentation adaptée pour soutenir le développement des enfants'
    }
  ];

  return (
    <section id="nutrition" className="py-20 bg-gradient-to-br from-green-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/6638236aecb37f11bdb72a3e29b156a6.jpg"
                alt="Nutrition et bien-être"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-leaf-line text-white text-2xl"></i>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-blue-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-restaurant-2-line text-white text-2xl"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Nutrition et bien-être
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Nous offrons des repas équilibrés et des collations santé, préparés avec soin pour soutenir la croissance et l'énergie des enfants tout au long de la journée.
            </p>

            <div className="space-y-6">
              {nutritionFeatures.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4 bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
